"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.save_order = void 0;
var api_1 = require("../../api");
var save_order = function (request) {
    return (0, api_1.apiPut)({
        endpoint: "v3/file/save_order",
        data: request,
    });
};
exports.save_order = save_order;
